import styled from 'styled-components';
import FilterTags from '@ertelecom/ui-react/components/navigation/filterTags';
import { ChannelSearch } from '~/src/components/ChannelSearch';
import bannerImage from './banner.png';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    width: 100%;
    display: block;
`;

export const Banner = styled.div`
    width: 100%;
    background: url(${bannerImage}) #8C5BBA;
    background-repeat: no-repeat;
    background-position: right;
    margin-top: ${props => props.isAuth ? '-9px' : '0'};
    @media (max-width: 1240px) {
        background-position: 370px;
    }
    @media (max-width: 860px) {
        margin-top: ${props => props.isAuth ? '110px' : '50px'};
        background-position: 300px;
    }
    @media (max-width: 460px) {
        background-position: 200px;
    }
`;
export const FiltersHeader = styled.div`
    width: 100%;
    background: ${COLORS.white};
`;
export const Content = styled.div`
    padding: 50px 0;
    width: 100%;
    max-width: 1440px;
    margin: 50px auto;
    padding: 0 7%;
    @media (max-width: 1180px) {
        margin: 30px auto;
    }
    @media(max-width: 860px) {
        padding: 0 15px;
    }
`;
export const FiltersContent = styled(Content)`
    flex-direction: column;
    @media (max-width: 1080px) {
        max-width: 100%;
        padding-right: 0;
    }
`;
export const BannerHeader = styled.h1`
    color: ${COLORS.white};
    font-size: 44px;
    line-height: 1.25em;
    max-width: 40%;
    margin: 0;
    @media (max-width: 1380px) {
        font-size: 40px;
    }
    @media (max-width: 640px) {
        max-width: 60%;
        font-size: 32px;
    }
    @media (max-width: 400px) {
        max-width: 200px;
    }
`;
export const MainContent = styled.div`
    background: ${COLORS.white};
    width: 100%;
    border-radius: 4px;
    padding: 0 40px 25px;
    @media (max-width: 1024px) {
        padding: 0 30px 20px;
    }
    @media (max-width: 640px) {
        padding: 0 20px 15px;
    }
`;
export const Search = styled(ChannelSearch)`
    @media(max-width: 860px) {
        padding-right: 15px;
    }
`;
export const ThemeFilter = styled(FilterTags)`
    margin-top: 30px;
`;
export const Link = styled.div`
    color: ${COLORS.blue};
    cursor: pointer;
    margin-bottom: 25px;
    & p {
        border-bottom: 1px dotted ${COLORS.blue};
    }
`;
